
<div class>
    <div class="file-upload-container">
        <!-- File Upload -->
      
      <p-toolbar class="custom-toolbar">
        <div class="p-toolbar-group-left">
          <!-- <img src="assets/logo.png" alt="Logo" class="logo"> -->
          <i class="pi pi-upload"></i>
          <span style="font-weight: 500;font-size: 24px;margin-left: 4px;">SOP</span>
        </div>
      
        <!-- <div class="p-toolbar-group-right">
          <button pButton icon="pi pi-home" label="Home" class="p-button-outlined"></button>
          <button pButton icon="pi pi-users" label="About Us" class="p-button-outlined"></button>
          <button pButton icon="pi pi-envelope" label="Contact" class="p-button-outlined"></button>
          <button pButton icon="pi pi-cog" label="Settings" class="p-button-warning"></button>
        </div> -->
      </p-toolbar>
      <p-fileUpload mode="advanced" accept=".xlsx, .xls,.docx,.pdf"   [showCancelButton]="true"   [showUploadButton]="true"
      customUpload="true"  (onSelect)="onFileSelected($event)" (uploadHandler)="uploadSopExcelFile()"></p-fileUpload>
        <!-- PrimeNG Table with Reorderable Columns -->
        <!-- <p-table [value]="users" [scrollable]="true" 
        scrollHeight="400px" 
        [resizableColumns]="true"   [paginator]="true" styleClass="p-datatable-gridlines"   [rows]="5"  > -->
        <p-table
      [value]="users"
      [scrollable]="true"
      [rowsPerPageOptions]="[5,10, 25, 50]"
      scrollHeight="550px"
      [resizableColumns]="true"
      currentPageReportTemplate="Showing {first} to {last} of {{users.length}} entries"
      [showCurrentPageReport]="true"
      columnResizeMode="expand"
      [paginator]="true"
      [rows]="5"
      styleClass="p-datatable-gridlines p-datatable-bordered"
      tableLayout="auto" 
      dataKey="id" >
     <!-- Define dataKey here -->
      <!-- Table header -->
      <ng-template pTemplate="header">
        <tr>
          <!-- <th pResizableColumn style="width: 50px;"></th> -->
          <th pResizableColumn>Document Name</th>
          <th pResizableColumn>Upload Time</th>
          <th pResizableColumn>Status</th>
          <th>Actions</th>
        </tr>
      </ng-template>
    
      <!-- Table body let-expanded="expanded"-->
      <ng-template pTemplate="body" let-user let-rowIndex="rowIndex" >
        <tr class="borders">
          <!-- <td>
            <button
              type="button"
              pButton
              pRipple
              [pRowToggler]="user"
              class="p-button-text p-button-rounded p-button-plain mr-2"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            ></button>
          </td> -->
          <td>{{ user?.name }}</td>
          <td>{{ formatTimestamp(user.genTs) }}</td>
          <td>
            {{ user?.status==='S'?('Success'):user?.status==='N'?('In Progress'):user?.status==='P'?('In Progress'):user?.status==='R'?('Uploaded with Remarks'):'Failed'}}
            
          </td>
          <td>
            <button
              pButton
              type="button"
              label="Download"
              icon="pi pi-download"
              (click)="generatePDF(user?.id, user?.name)"
              class="rocket-button"
            ></button>
          </td>
        </tr>
      </ng-template>
    
      <!-- Row expansion template -->
      <!-- <ng-template pTemplate="rowexpansion" let-user>
        <tr>
          <td colspan="5">
            <p-table
            [value]="user.remarks"
            scrollHeight="400px"
            [resizableColumns]="true"
            [rows]="3"
             
          >
           
            <ng-template pTemplate="header">
              <tr>
                <th pResizableColumn>User Name</th>
                <th pResizableColumn>User Status</th>
                <th pResizableColumn>Log</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-remark let-rowIndex="rowIndex" >
              <tr>
                <td>{{remark?.username}}</td>
                <td>{{remark?.userStatus}}</td>
                <td>{{remark?.log}}</td>
    </tr>
  </ng-template>
          </p-table>      </td>
        </tr>
      </ng-template> -->
    </p-table>
      </div>
      
    